<template>
  <v-container style="background-color: #21343b" :class="$vuetify.breakpoint.width < 1264 ? 'px-7' : 'pl-12 pr-4'">
    <v-row>
      <v-col class="pt-0 pb-0 mt-5 text-left">
        <label for="fullName" class="text-left" style="color: white">
          <b>{{ $t('eMailNotificationSetting') }}</b>
        </label>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-radio-group
          :class="$vuetify.breakpoint.width < 1264 ? 'mx-0 chk' : 'mx-10 chk'"
          v-model="emailType"
          @change="changeType(emailType)"
        >
          <v-row class="mb-5">
            <v-col>
              <label for="always" class="text-left" style="color: white">{{ $t('notiPrefAlways') }}</label>
            </v-col>
            <v-radio id="always" value="always"></v-radio>
          </v-row>
          <v-row class="mb-5">
            <v-col>
              <label for="mentioned" class="text-left" style="color: white">{{ $t('notiPrefRequested') }}</label>
            </v-col>
            <v-radio id="mentioned" value="mentioned"></v-radio>
          </v-row>
          <v-row class="mb-5">
            <v-col>
              <label for="never" class="text-left" style="color: white">{{ $t('notiPrefNever') }}</label>
            </v-col>
            <v-radio id="never" value="never"></v-radio>
          </v-row>
        </v-radio-group>
      </v-col>
    </v-row>

    <!-- <v-divider class="mt-5" color="#E2E2E2" /> -->
  </v-container>
</template>

<script>
import { getUserSetting, updateUserSetting } from '@/services/api'
import { isMobile } from '@/common/lib/strLib'
// import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'NotiSetting',
  created() {
    this.getSetting()
  },
  data() {
    return {
      emailType: '',
    }
  },
  methods: {
    async getSetting() {
      try {
        let result = await getUserSetting(this, this.$store.getters.selectedWsInfo.wsId)
        if (
          result &&
          result !== null &&
          result.emailNotiType &&
          result.emailNotiType !== null &&
          result.emailNotiType !== ''
        ) {
          this.emailType = result.emailNotiType
        } else {
          this.changeType('always')
        }
      } catch (err) {
        console.log()
      }
    },

    async changeType(type) {
      try {
        let result = await updateUserSetting(this, this.$store.getters.selectedWsInfo.wsId, type)
        if (
          result &&
          result !== null &&
          result.emailNotiType &&
          result.emailNotiType !== null &&
          result.emailNotiType !== ''
        ) {
          this.emailType = result.emailNotiType
        }
      } catch (err) {
        console.log()
      }
      // this.emailType = type
    },
  },
  computed: {
    isMobile() {
      return isMobile()
      // return true
    },
  },
}
</script>

<style scoped>
.chk >>> .theme--light.v-icon {
  color: white;
}

.chk >>> .text-left {
  cursor: pointer;
}

.chk {
  font-size: 14px;
}
</style>
